import { Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export default function Step({
  title,
  stepNumber,
  currentStep,
  numScreens,
  currentScreen,
}: {
  title: string;
  stepNumber: number;
  currentStep: number;
  numScreens: number;
  currentScreen: number;
}) {
  return (
    <Flex direction="column" gap="xxxs" style={{ flex: 1 }}>
      <Flex gap="xs">
        {Array.from({ length: numScreens }, (_, screenIndex) => {
          const isCurrentScreen = stepNumber === currentStep && screenIndex === currentScreen;
          const isPastScreen =
            stepNumber < currentStep || (stepNumber === currentStep && screenIndex < currentScreen);
          const isActiveOrPast = isCurrentScreen || isPastScreen;

          return (
            <div
              key={screenIndex}
              style={{
                height: '4px',
                flex: 1,
                borderRadius: '24px',
                backgroundColor: isActiveOrPast
                  ? 'var(--mantine-color-brand-6)'
                  : 'var(--mantine-color-brand-2)',
              }}
            />
          );
        })}
      </Flex>
      <Text size="textXs" fw={FONT_WEIGHTS.medium}>
        Step {stepNumber + 1}: {title}
      </Text>
    </Flex>
  );
}
